import React from "react";
import { createNowButton } from "@/assets/svgs/gradientIcons";

const HeroSectionBG = `${process.env.PUBLIC_URL || ""}/LandingPageAssets/HeroSectionBG.png`;

export const HeroSection = () => {
  return (
    <div className="relative min-h-screen lg:h-screen lg:min-h-[800px] lg:max-h-[960px] w-full text-white font-sora overflow-hidden bg-[#05070a] flex flex-col justify-center">
      {/* Background Image */}
      <div
        className="absolute inset-0 bg-cover bg-[center_top] bg-no-repeat opacity-100"
        style={{ backgroundImage: `url(${HeroSectionBG})` }}
      />

      {/* Bottom Fade Mask */}
      <div className="absolute inset-x-0 bottom-0 h-64 bg-gradient-to-b from-transparent via-[#05070a]/80 to-[#05070a] pointer-events-none z-0" />

      {/* Hero Content */}
      <div className="relative z-10 flex flex-col items-center justify-center text-center px-6 pt-20 sm:pt-24">
        <h1
          className="text-3xl sm:text-4xl md:text-5xl lg:text-[54px] xl:text-[58px] font-semibold tracking-tight max-w-5xl leading-[1.2] m-0 text-white"
          style={{
            textShadow: "0 4px 30px rgba(0,0,0,0.9), 0 2px 10px rgba(0,0,0,0.7)",
            wordSpacing: "0.12em",
          }}
        >
          {/* <span className="block">
            Create 
            {/* <span className="text-[#62FAE3]">Idea</span> 
            into{" "}
            <span className="text-[#62FAE3]">Viral,</span> */}
          {/* </span> */} 
          <span className="block">
            Create
            <span className="whitespace-nowrap">
              <span className="text-[#62FAE3]"> Jaw-</span>
              <span className="text-[#D0BCFF]">Dropping</span>
            </span>{" "}
              <span className="text-[#62FAE3]">VIDEOS</span>
          </span>
          <span className="block">
          Automate  <span className="text-[#62FAE3]"> Publishing.</span>
          </span>
          <span className="block">
          Grow your  <span className="text-[#62FAE3]"> CHANNEL.</span>
          
          </span>
        </h1>

        <div className="mt-8 sm:mt-10">
          <a
            href="#who-it-is-for"
            className="inline-flex items-center justify-center w-[140px] sm:w-[160px] md:w-[180px] h-auto transition-transform duration-300 hover:scale-105 hover:brightness-110 active:scale-95 cursor-pointer"
            dangerouslySetInnerHTML={{ __html: createNowButton }}
          />
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
